<div id="validatePatientEncounters" class="card mt-1">
  <h6 class="card-title m-0 px-2 py-1 d-flex">
    <mat-icon>event</mat-icon>
    <div class="ms-1 pt-1">Patient Encounters</div>
  </h6>
  <div class="card-body p-1">

    @if (showIneligibleEncounters) {
      <nav class="nav nav-pills mb-2">
        <a class="nav-item nav-link active"
          [class.active]="currentTab === 'eligibleEncounters'"
          (click)="tabClick($event, 'eligibleEncounters')"
          href="#">
          Eligible Encounters ({{ eligibleEncounters.length }})
        </a>
        <a class="nav-item nav-link"
          [class.active]="currentTab === 'ineligibleEncounters'"
          (click)="tabClick($event, 'ineligibleEncounters')"
          href="#">
          Ineligible Encounters ({{ ineligibleEncounters.length }})
        </a>
      </nav>
    }

    @if (!showIneligibleEncounters || currentTab === 'eligibleEncounters') {
      <ng-container
        [ngTemplateOutlet]="encounterList"
        [ngTemplateOutletContext]="{ encounters: eligibleEncounters }" />
    }

    @if (currentTab === 'ineligibleEncounters') {
      <ng-container
        [ngTemplateOutlet]="encounterList"
        [ngTemplateOutletContext]="{ encounters: ineligibleEncounters, rowClass: 'ineligible' }" />
    }


    @if (moreEncountersThanDisplayed) {
      <div class="p-1 pt-0 mt-0">
        Only displaying patient's 20 most recent encounters;
        <a target="_blank" routerLink="/capture-admin/patients/{{ patient.id }}/encounters">click here to see all</a>.
      </div>
    }
  </div>
</div>

<ng-template #encounterList let-encounters="encounters" let-rowClass="rowClass">
  @if (!loading && encounters.length > 0) {
    <table class="table table-sm">
      <thead class="table-dark">
        <tr>
          <th>ID</th>
          <th>DATE</th>
          <th>PROVIDER</th>
          <th>ENC-LOCATION</th>
          <th>ENC-TYPE</th>
        </tr>
      </thead>
      <tbody>
        @for (encounter of encounters; track encounter) {
          <tr class="encounter" [ngClass]="rowClass">
            <td>{{ encounter.ehrIdentifier }}</td>
            <td>{{ encounter.encounterDate | date: 'MM/dd/yyyy' }}</td>
            <td>{{ encounter.providerDisplayNameWithNpi }}</td>
            <td>{{ encounter.location }}</td>
            <td>{{ encounter.encounterType }}</td>
          </tr>
        }
      </tbody>
    </table>
  } @else {
    <div class="m-2">No encounters found.</div>
  }
</ng-template>

